/* eslint-disable no-else-return */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { Button } from 'reactstrap'
import { claimActions } from '../../../redux/actions'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import UplayIntegration from '../../../components/UplayIntegration/UplayIntegration'
import SteamIntegration from '../../../components/SteamIntegration/SteamIntegration'
import MicrosoftIntegration from '../../../components/MicrosoftIntegration/MicrosoftIntegration'
import EpicIntegration from '../../../components/EpicIntegration/EpicIntegration'
import RCIntegration from '../../../components/RCIntegration/RCIntegration'
import ActivationKey from '../../../components/ActivationKey/ActivationKey'
import Loader from '../../../components/Loader/Loader'
import ImageUrlUtil from '../../../utilities/boxImageUrlFormatter'
import { findWebGL } from '../../../utilities/webGL'

import './Summary.scss'

class Summary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    const {
      redeemContent,
      claim: { couponCode, tokenCode, selectedContentList, survey },
    } = this.props
    const webGL = findWebGL()

    redeemContent(couponCode, tokenCode, selectedContentList, webGL, survey)
      .then(() => this.setState({ loading: false }))
      .catch(e => console.error('Failed redeemContent'))
  }

  _buildActiveContentImageSrc = imageUrl => ImageUrlUtil(imageUrl)

  _renderPromotionStep = promotion =>
    promotion.selectedContent.map(content => (
      <div
        className="row mb-4"
        key={`${content.content.name}-${content.content.content_provider.name}`}
      >
        <div className="col-12 col-md-auto justify-content-center">
          <div className="d-flex justify-content-center">
            <img
              src={this._buildActiveContentImageSrc(content.imageUrl)}
              className="summary-activation-content-image"
              alt={content.content.name}
            />
          </div>
        </div>
        <div className="col">
          <h4 className="mt-3" id={`summary-content-heading-${content.contentId}`}>
            {`${content.content.name} - `}
            <FormattedMessage
              id={`contentProvider.${content.content.content_provider.name}.content.name`}
            />
          </h4>
          {content.assign &&
          ((content.activationKey && content.staticKey) ||
            (!content.staticKey && content.activationKey)) ? (
            <div>
              <p className="header">
                <FormattedMessage
                  id={`contentProvider.${content.content.content_provider.name}.header.description`}
                  values={{ contentTitle: content.content.name }}
                />
              </p>
              <p className="instructions">
                <FormattedHTMLMessage
                  id={`contentProvider.${content.content.content_provider.name}.instruction.text`}
                />
              </p>
            </div>
          ) : (
            <>
              <FormattedMessage id="global.label.checkMyRewards" />
              <div className="mb-3 mt-3">
                <div className="row">
                  <div className="col">
                    <Button
                      color="dark"
                      block
                      outline
                      onClick={() => {
                        window.location.href = '/my-rewards'
                      }}
                      aria-label="Go to my rewards"
                    >
                      <FormattedMessage id="page.myRewardsPage.title.heroTitle" />
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
          <p className="header mt-3">
            <FormattedMessage
              id="global.label.releaseDate"
              values={{ date: content.content.releaseDate ? content.content.releaseDate : 'TBD' }}
            />
          </p>
          <p className="header">
            <FormattedMessage id="global.general.releaseDateDisclaimer" />
          </p>
          {content.assign &&
          ((content.activationKey && content.staticKey) ||
            (!content.staticKey && content.activationKey))
            ? this.renderContentKey(content)
            : null}

          <div className="my-3">
            <div className="d-flex flex-wrap">
              {content.content.contentRatings.map((ratings, index) => (
                <div key={ratings.rating.id} className="d-flex">
                  <img
                    src={ratings.rating.fileName}
                    key={ratings.rating.name}
                    alt={ratings.rating.name}
                    className={`mb-3 img-fluid contentItem-page__ratingImg ${
                      index === 0 ? 'mr-1' : 'mx-1'
                    }`}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <p className="content-attribute m-0">{content.legalAttributeTitle}</p>
            <p className="content-attribute m-0">{content.legalAttributeDescription}</p>
            <p className="content-attribute m-0">
              <span dangerouslySetInnerHTML={{ __html: content.legalAttributeUrl }} />
            </p>
            <p className="content-attribute m-0">
              <FormattedMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.title`}
              />
            </p>
            <p className="content-attribute m-0">
              <FormattedMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.description`}
              />
            </p>
            <p className="content-attribute m-0">
              <FormattedHTMLMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.url`}
              />
            </p>
          </div>
        </div>
      </div>
    ))

  _renderSelectedContent = () =>
    this.props.claim.selectedContentList.map((promotion, index) => (
      <div key={index}>
        {this._renderPromotionStep(promotion)}
        {promotion.selectedContent.length &&
        this.props.claim.selectedContentList.length > 1 &&
        index !== this.props.claim.selectedContentList.length - 1 ? (
          <div className="hr my-5" />
        ) : (
          ''
        )}
      </div>
    ))

  renderContentKey(content) {
    const {
      contentId,
      activationKey,
      staticKey,
      content: {
        name,
        thirdPartyRedeemed,
        content_provider: { name: provider },
      },
    } = content
    const {
      claim: { couponCode },
    } = this.props

    if (staticKey) {
      return <ActivationKey activationKey={activationKey} staticKey={staticKey} />
    } else if (activationKey && provider === 'Ubisoft') {
      return (
        <UplayIntegration
          redeemed={thirdPartyRedeemed}
          contentName={name}
          activationKey={activationKey}
          contentId={contentId}
          couponCode={couponCode}
        />
      )
    } else if (activationKey && provider === 'Steam') {
      return (
        <SteamIntegration
          redeemed={thirdPartyRedeemed}
          contentName={name}
          activationKey={activationKey}
          contentId={contentId}
          couponCode={couponCode}
        />
      )
    } else if (activationKey && provider === 'Microsoft') {
      return <FormattedMessage id="global.label.checkMyRewards" />
      // ADD IN MICROSOFT INTEGRATION ONCE LOGGING ISSUE ON SUMMARY PAGE IS SOLVED
      // return (<MicrosoftIntegration redeemed={thirdPartyRedeemed} contentName={name} activationKey={activationKey} contentId={contentId} couponCode={couponCode} />)
    } else if (activationKey && provider === 'Epic') {
      return (
        <EpicIntegration
          redeemed={thirdPartyRedeemed}
          contentName={name}
          activationKey={activationKey}
          contentId={contentId}
          couponCode={couponCode}
        />
      )
    } else if (activationKey && provider === 'RobotCache') {
      return (
        <RCIntegration
          redeemed={thirdPartyRedeemed}
          contentName={name}
          activationKey={activationKey}
          contentId={contentId}
          couponCode={couponCode}
        />
      )
    }
    return <ActivationKey activationKey={activationKey} staticKey={staticKey} />
  }

  render() {
    const { loading } = this.state
    const {
      claim: { currentPromotion },
    } = this.props

    if (loading) {
      return (
        <div className="row align-items-center">
          <Loader noBorder />
          &nbsp;&nbsp;&nbsp;
          <FormattedMessage id="page.redemptionPage.text.messageAssigningCouponCode" />
        </div>
      )
    }

    return (
      <div aria-labelledby="summary-promotion-heading">
        <h4 id="summary-promotion-heading">{currentPromotion.name}</h4>
        <p>
          <FormattedMessage id="page.redemptionPage.text.confirmReward" />
        </p>
        {this._renderSelectedContent()}
        <div className="my-4">
          <FormattedMessage id="global.label.surveyText" />
        </div>
        <div>
          <a
            href="https://www.feedback.amd.com/se/5A1E27D2606D032C"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="dark" outline aria-label="Take survey">
              <FormattedMessage id="global.label.survey" />
            </Button>
          </a>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  claim: state.claimReducers,
})

const mapDispatchToProps = dispatch => ({
  clearRedeemState: () => dispatch(claimActions.clearRedeemState()),
  redeemContent: (...args) => dispatch(claimActions.redeemContent(...args)),
  recordRevealKey: (...args) => dispatch(claimActions.logRevealKey(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
